var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useContext, useEffect, useState } from 'react';
import { AccountAvatar, FilterGroup, LoadingBounce, NoFilter, useDialogs, useListSelectFilter, } from '@michelin/acid-components';
import DataGrid, { Column, SearchPanel, } from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { getLocationAcidAccountNumbers, getLocationAcidAddress, } from './utils';
import './CustomerList.css';
import { canadianProvinces, usStates } from './filterValues';
import { isFleetLocation, isProviderLocation, getLocationByNumber } from '../../helpers/customers';
import { loggerError } from '../../helpers/Log';
import { useMaestroDataSource } from '../../helpers/maestroDataSource';
import { api, centralPathOverwrite } from '../../environment.vars';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
var manualAccountSelections = 0;
export function getManualAccountSelectionsPeformed() {
    return manualAccountSelections;
}
function locationInGrant(grant, location) {
    if (!grant)
        return false;
    if (!grant.locations)
        return false;
    var found = grant.locations.find(function (l) {
        var locations = l.locations || [];
        // @ts-ignore
        if (location.ship_to_customer && locations.includes(location.ship_to_customer))
            return true;
        if (location.bill_to_customer && locations.includes(location.bill_to_customer))
            return true;
        if (location.home_office_number && locations.includes(location.home_office_number))
            return true;
        // @ts-ignore
        if (location.parent_company_number && locations.includes(location.parent_company_number))
            return true;
        return false;
    });
    return found !== undefined;
}
function findGrant(grants, location) {
    var grant = grants.find(function (g) {
        var amp = get(g, 'role.permissions.accounts_manager');
        if (amp) {
            if (isFleetLocation(location) && amp.manage_all_fleets)
                return true;
            if (isProviderLocation(location) && amp.manage_all_providers)
                return true;
        }
        else {
            // The else section needs to be deprecated soon
            // (once every app has accounts_manager on it's role definition)
            var role = g.role.name.toLocaleLowerCase();
            if (role === 'michelin employee')
                return true;
            if (role === 'michelin administrator')
                return true;
            if (role === 'dsp central administrator')
                return true;
        }
        if (locationInGrant(g, location))
            return true;
        return false;
    }) || null;
    if (!grant)
        return null;
    var newGrant = __assign(__assign({}, grant), { accounts: [location] });
    return newGrant;
}
export function selectAccountByNumber(customerNumber, centralProviderContext, customerLevels) {
    return __awaiter(this, void 0, void 0, function () {
        var cf, grant_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getLocationByNumber(customerNumber, centralProviderContext.application, customerLevels)];
                case 1:
                    cf = _a.sent();
                    if (!cf)
                        return [2 /*return*/, false];
                    grant_1 = findGrant((centralProviderContext && centralProviderContext.centralProfile && centralProviderContext.centralProfile.grants) || [], cf);
                    if (!grant_1)
                        return [2 /*return*/, false];
                    setTimeout(function () { return centralProviderContext.setCurrentGrant(grant_1); }, 0);
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    loggerError('Error setting account from URL!', e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    });
}
function AccountListItem(_a) {
    var _this = this;
    var cf = _a.cf, onClick = _a.onClick, cellView = _a.cellView, searchValue = _a.searchValue;
    // eslint-disable-next-line no-underscore-dangle
    var score = cf._score || 1000;
    var useMdmId = useContext(CentralProviderContext).useMdmId;
    var alertDialog = useDialogs().alertDialog;
    return (React.createElement("div", { style: { zoom: 1.1, opacity: searchValue && score < 190 ? 0.5 : undefined }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!onClick)
                    return [2 /*return*/];
                if (cf.customer_number === '1322545') {
                    alertDialog("You can't use this account on this system directly, please select one of it's BT or ST instead.", 'Acount not available on this application');
                    return [2 /*return*/];
                }
                // checkTransitionAllowed
                onClick(cf);
                return [2 /*return*/];
            });
        }); } },
        React.createElement(AccountAvatar, { name: cf.customer_dba_name || cf.customer_name || ' ', accountType: cf.customer_type, address: getLocationAcidAddress(cf), addressDisplay: cellView ? 'cityState' : 'full', accountNumbers: getLocationAcidAccountNumbers(cf, useMdmId), style: {
                cursor: onClick && 'pointer',
                whiteSpace: 'normal',
            } })));
}
function buildCustomerTypeOptions(levels, t) {
    var options = [];
    if (!levels || levels.includes('PC'))
        options.push({ label: t('Parent Company'), value: 'pc' });
    if (!levels || levels.includes('HO'))
        options.push({ label: t('Home Office'), value: 'ho' });
    if (!levels || levels.includes('BT'))
        options.push({ label: t('Bill To'), value: 'bt' });
    if (!levels || levels.includes('ST'))
        options.push({ label: t('Ship To'), value: 'st' });
    return options;
}
function buildCustomerCountryOptions(countryCodes, t) {
    var options = [];
    var ccodes = countryCodes.length ? countryCodes : ['us', 'ca'];
    ccodes.forEach(function (code) {
        options.push({ label: t("COUNTRY_CODE|".concat(code.toLocaleUpperCase())), value: code.toLocaleLowerCase() });
    });
    return options;
}
export function CustomerList(_a) {
    var onClose = _a.onClose, levels = _a.levels, accountType = _a.accountType, countryCodes = _a.countryCodes, enableStateFiltering = _a.enableStateFiltering, custChnlCodes = _a.custChnlCodes;
    var theme = useTheme();
    var tabletView = useMediaQuery(theme.breakpoints.down(800), { noSsr: true });
    var cellView = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
    var t = useTranslation().t;
    var _b = useContext(CentralProviderContext), currentLanguage = _b.currentLanguage, application = _b.application, selectedGrant = _b.selectedGrant, centralProfile = _b.centralProfile, setCurrentGrant = _b.setCurrentGrant, setSelectingGrant = _b.setSelectingGrant;
    var errorDialog = useDialogs().errorDialog;
    var customerTypeOpts = buildCustomerTypeOptions(levels, t);
    var customerLevel = useListSelectFilter({
        label: '',
        defaultValue: customerTypeOpts.length === 1 ? customerTypeOpts[0].value : undefined,
        options: customerTypeOpts,
        unselectedLabel: t('Any Account Type'),
    });
    var customerCountryOpts = buildCustomerCountryOptions(countryCodes, t);
    var customerCountry = useListSelectFilter({
        label: '',
        options: customerCountryOpts,
        unselectedLabel: t('Any Country'),
    });
    var customerUSState = useListSelectFilter({
        label: '',
        options: usStates,
        unselectedLabel: t('Any State'),
    });
    var customerCanadianProvince = useListSelectFilter({
        label: '',
        options: canadianProvinces[currentLanguage || 'en_US'],
        unselectedLabel: t('Any Province'),
    });
    var _c = __read(useState(new FilterGroup(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read((customerTypeOpts.length > 1 ? [customerLevel.filter] : [])), false), __read((customerCountryOpts.length > 1 ? [customerCountry.filter] : [])), false), __read((enableStateFiltering && customerCountry.value === 'ca' ? [customerCanadianProvince.filter] : [])), false), __read((enableStateFiltering && customerCountry.value === 'us' ? [customerUSState.filter] : [])), false), __read((enableStateFiltering && !customerCountry.value ? [new NoFilter()] : [])), false))), 2), filterGroup = _c[0], setFilterGroup = _c[1];
    useEffect(function () {
        if (!enableStateFiltering)
            return;
        filterGroup.filters.pop();
        switch (customerCountry.value) {
            case 'us':
                filterGroup.filters.push(customerUSState.filter);
                break;
            case 'ca':
                filterGroup.filters.push(customerCanadianProvince.filter);
                break;
            default:
                filterGroup.filters.push(new NoFilter());
                break;
        }
        setFilterGroup(filterGroup);
    }, [customerCountry.value]);
    var ds = useMaestroDataSource({
        API: {
            method: 'GET',
            endpoint: "".concat(centralPathOverwrite, "/users/accounts"),
            baseURL: api,
        },
        reqOptions: {
            filters: {
                customerLevel: customerLevel.value || (levels === null || levels === void 0 ? void 0 : levels.join(',')) || undefined,
                accountType: accountType,
                custChnlCodes: custChnlCodes && custChnlCodes.length > 0
                    ? custChnlCodes.join(',')
                    : undefined,
                state: 
                // eslint-disable-next-line no-nested-ternary
                customerCountry.value === 'us'
                    ? customerUSState.value
                    : customerCountry.value === 'ca'
                        ? customerCanadianProvince.value
                        : undefined,
                countryCodes: customerCountry.value || countryCodes.join(',').toLocaleLowerCase(),
                app_key: application,
            },
        },
        componentPlacements: {
            filtersPlacement: tabletView ? 'outside' : 'embeded',
            searchPlacement: cellView ? 'outside' : 'embeded',
        },
        filterGroup: filterGroup,
        phoneView: cellView,
    });
    var _d = __read(useState(null), 2), switchingTo = _d[0], setSwitchingTo = _d[1];
    if (selectedGrant && selectedGrant.accounts.length === 1
        && selectedGrant.accounts[0] === switchingTo) {
        onClose();
        return null;
    }
    var onCustomerSelect = function (cf) {
        setSwitchingTo(cf);
        manualAccountSelections++;
        var grant = findGrant((centralProfile && centralProfile.grants) || [], cf);
        setTimeout(function () {
            if (!grant) {
                setSwitchingTo(null);
                errorDialog("Can't find a grant including the selected location.", 'Fatal Error');
                return;
            }
            // select grant
            setCurrentGrant(grant);
            setSelectingGrant(false);
        }, 1);
    };
    if (switchingTo) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    zoom: 1.7, margin: '18px auto 0', opacity: 0.4, width: '50%',
                } },
                React.createElement(AccountListItem, { cf: switchingTo, cellView: cellView })),
            React.createElement(LoadingBounce, { style: { height: '70px', zoom: 0.8 } })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null, tabletView ? ds.renderFilterFields(null, { margin: 10 }) : undefined),
        React.createElement(DataGrid, { id: "accountsTable", dataSource: ds.dataSource, remoteOperations: true, rowAlternationEnabled: true, noDataText: t('No accounts found...'), style: { height: cellView ? '85vh' : '60vh' }, scrolling: { mode: 'virtual', rowRenderingMode: 'virtual' }, onToolbarPreparing: ds.onToolbarPreparing },
            React.createElement(Template, { name: "filterFields", render: ds.renderFilterFields }),
            React.createElement(Template, { name: "resultsCounter", render: ds.renderResultsCounter }),
            React.createElement(SearchPanel, { visible: true, highlightSearchText: false, placeholder: t('Search...') }),
            React.createElement(Column, { dataField: "account", dataType: "string", cellRender: function (x) {
                    var _a;
                    return (React.createElement(AccountListItem, { cf: x.row.data, searchValue: (_a = x.component.getCombinedFilter()) === null || _a === void 0 ? void 0 : _a.filterValue, onClick: onCustomerSelect, cellView: cellView }));
                } }))));
}
//# sourceMappingURL=CustomerList.js.map